<!-- Item Start Outlet -->
<ng-template [cxOutlet]="CartOutlets.LIST_ITEM">
  <td role="cell">
    <ng-template [cxOutlet]="CartOutlets.ITEM_CONFIGURATOR_ISSUES"></ng-template>
    <gen-cart-item-validation-warning [code]="item.product?.code"></gen-cart-item-validation-warning>
    <div class="cx-table-item-container"
      [ngClass]="{'cx-table-bundle-item': bundleId, 'cx-table-subscription-item': isSubscription && isReviewOrder}">
      <ng-container *ngIf="!bundleId && !isSubscription;">
        <a (click)="navigateToProduct()" tabindex="0">
          <cx-media class="cx-product-image"
            *ngIf="(item.product.servicePart && item.product.images?.PRIMARY) || !item.product.servicePart; else spGearThumb"
            [container]="item.product?.images?.PRIMARY" format="cartIcon"
            [alt]="item.product.name || item.product.summary"></cx-media>
          <ng-template #spGearThumb>
            <div class="sp-gear-thumb">
              <img src="../../../../../../assets/icons/sp_gear_thumb.svg" alt="gear">
            </div>
          </ng-template>
        </a>
      </ng-container>

      <ng-container *ngIf="isSubscription;">
        <cx-media [container]="item.product?.images?.PRIMARY" format="cartIcon"></cx-media>
      </ng-container>

      <div class="cx-info">
        <!-- Item Name -->
        <cx-icon *ngIf="bundleId" [ngClass]="{'collapsed': isBundleCollapsed}" class="collapse-icon"
          [type]="iconTypes.CARET_DOWN" (click)="onExpandToggle()"></cx-icon>
        <div class="cx-info-block" #cartItemInfo>
          <div *ngIf="item.product?.name" class="cx-name">

            <ng-container *ngIf="!isSubscription; else itemNameForSubscription">
              <a class="cx-link"
                [routerLink]="['/product/' + this.item.product.code + '/' + transformNameToUrl(this.item.product.name)]"
                tabindex="0">
                {{ item.product?.name }} <span *ngIf="bundleId">Bundle</span>
              </a>
            </ng-container>

            <ng-template #itemNameForSubscription>
              <strong>{{ item.product?.name }}</strong>
            </ng-template>

          </div>

          <ng-container *ngIf="!bundleId && ((!isReviewOrder) || (!isSubscription && isReviewOrder))">
            <div *ngIf="item.product?.code && !item.product?.displayModelNumber" class="cx-code">
              {{ (item.product?.servicePart ? 'cartItems.part' : 'cartItems.id') | cxTranslate }} #{{ item.product?.code
              }}
            </div>
            <div *ngIf="item.product?.displayModelNumber" class="cx-code">
              {{ (item.product?.servicePart ? 'cartItems.part' : 'cartItems.id') | cxTranslate }} #{{
              item.product?.displayModelNumber }}
            </div>
          </ng-container>
          <!-- Item Price -->
          <div *ngIf="item.basePrice && ((!isReviewOrder) || (!isSubscription && isReviewOrder))"
            class="cx-price cx-mobile-only">
            <div *ngIf="item.basePrice" class="cx-value">
              {{ item.basePrice?.formattedValue }}
            </div>
          </div>
          <!-- Mobile Item Price -->
          <!-- Item Quantity -->
          <div role="cell" class="cx-quantity cx-mobile-only">
            <div class="cx-mobile-header" placement="left" title="{{ 'cartItems.quantityTitle' | cxTranslate }}">
              {{ "cartItems.quantity" | cxTranslate }}
            </div>
            <div class="cx-value justify-center" [class.readonly-value]="readonly">
              <div *ngIf="isBundleItem;else notABundleItem">{{quantityControl?.value}}</div>

              <ng-template #notABundleItem>
                <gen-item-counter *ngIf="!isBundleItem && quantityControl" [control]="quantityControl" [item]="item"
                  [readonly]="!item.updateable || readonly || options.isSaveForLater"
                  [min]="+item.product?.minOrderQuantity"
                  [max]="bundleId ? +maxItemsAllowed : +item.product?.maxOrderQuantity"
                  [step]="+item.product?.addToCartQtyMultiplier" [isBundle]="!!bundleId"
                  [allowZero]="true"></gen-item-counter>
              </ng-template>
            </div>
          </div>
          <!-- Total -->
          <div class="cx-mobile-only">
            <ng-container *ngIf="options.isSaveForLater; else total">
              <div role="cell" class="cx-total cx-mobile-only">
                <div class="cx-mobile-header">
                  {{ "saveForLaterItems.stock" | cxTranslate }}
                </div>
                <div *ngIf="item.product?.stock?.stockLevel >= 0; else forceInstock" class="cx-value">
                  {{ item.product?.stock.stockLevel }}
                </div>
                <ng-template #forceInstock>
                  <div class="cx-value">
                    {{ "saveForLaterItems.forceInStock" | cxTranslate }}
                  </div>
                </ng-template>
              </div>
            </ng-container>
          </div>
          <div class="sp-product-icons" *ngIf="item.product?.servicePart && isCartPage">
            <gen-sp-icons [product]="item.product" [changeTooltipPosition]="true"
              [showGreenCheck]="item.itemOnHand"></gen-sp-icons>
          </div>
          <ng-container *ngIf="!isBundleItem && item.promotions?.length">
            <cx-promotions #promotions (genSizeChanged)="onResize(!!item.product.displayItemAttentionMessage)"
              [ngClass]="{'bundle': bundleId}" [promotions]="item.promotions"></cx-promotions>
          </ng-container>
          <div class="cx-code cx-delivery">
            <ng-container
              *ngIf="!bundleId && item.availabilityMessage && ((!isReviewOrder) || (!isSubscription && isReviewOrder))">
              <img src="../../../../../../assets/icons/delivery_icon_black_24.svg" />
              <span class="availability-msg">{{ item.availabilityMessage }}</span>
            </ng-container>
            <div class="sp-product-icons" *ngIf="item.product?.servicePart && !isCartPage">
              <gen-sp-icons [product]="item.product" [changeTooltipPosition]="true"
                [showGreenCheck]="item.itemOnHand"></gen-sp-icons>
            </div>
          </div>

          <ng-container *ngIf="sppFormValue && !mobileOnly">
            <button class="btn add-consumer-details-btn"
              [class.add-consumer-details-btn-expanded]="isConsumerDetailsSectionExpanded"
              (click)="expandConsumerDetailsSection()" (genSizeChanged)="onResize()">
              {{ (isBuilderSpp() ? 'cartItems.addBuilderDetails' : 'cartItems.addConsumerDetails') | cxTranslate }}
              <img src="../../../../../../assets/icons/expand_more_black_24.svg" />
            </button>

            <gen-spp-consumer-details-form [ngStyle]="{ 'margin-top': consumerFormTopMargin }"
              [hidden]="!isConsumerDetailsSectionExpanded" [sppFormValue]="sppFormValue" #consumerDetailsSection
              [quantity]="item.quantity" (genSizeChanged)="onResize()"
              [entryNumber]="item.entryNumber"></gen-spp-consumer-details-form>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="cx-cart-addons">
      <!-- Item Details Outlet -->
      <ng-template [cxOutlet]="CartOutlets.ITEM_DETAILS"> </ng-template>

      <!-- Item Bundle Details Outlet -->
      <ng-template [cxOutlet]="CartOutlets.ITEM_BUNDLE_DETAILS"> </ng-template>

    </div>

    <!-- Variants -->
    <ng-container *ngIf="item.product?.baseOptions?.length">
      <div *ngFor="
          let variant of item.product?.baseOptions[0]?.selected
            ?.variantOptionQualifiers
        " class="cx-property">
        <!-- cx-mobile-header -->
        <div class="cx-label" *ngIf="variant.name && variant.value">
          {{ variant.name }}: {{ variant.value }}
        </div>
      </div>
    </ng-container>
  </td>
  <!-- Item Quantity -->
  <td role="cell" class="cx-quantity desktop-only">
    <div class="cx-mobile-header" placement="left" title="{{ 'cartItems.quantityTitle' | cxTranslate }}">
      {{ "cartItems.quantity" | cxTranslate }}
    </div>
    <div class="cx-value justify-center" [class.readonly-value]="readonly">
      <div *ngIf="isBundleItem;else notABundleItem">{{quantityControl?.value}}</div>

      <ng-template #notABundleItem>
        <gen-item-counter *ngIf="!isBundleItem && quantityControl" [control]="quantityControl" [item]="item"
          [readonly]="!item.updateable || readonly || options.isSaveForLater" [min]="+item.product?.minOrderQuantity"
          [max]="bundleId ? +maxItemsAllowed : +item.product?.maxOrderQuantity"
          [step]="+item.product?.addToCartQtyMultiplier" [isBundle]="!!bundleId" [allowZero]="true"></gen-item-counter>
      </ng-template>
    </div>
  </td>
  <!-- Total -->
  <div class="desktop-only total-desktop-wrap">
    <ng-container *ngIf="options.isSaveForLater; else total">
      <td role="cell" class="cx-total desktop-only">
        <div class="cx-mobile-header">
          {{ "saveForLaterItems.stock" | cxTranslate }}
        </div>
        <div *ngIf="item.product?.stock?.stockLevel >= 0; else forceInstock" class="cx-value">
          {{ item.product?.stock.stockLevel }}
        </div>
        <ng-template #forceInstock>
          <div class="cx-value">
            {{ "saveForLaterItems.forceInStock" | cxTranslate }}
          </div>
        </ng-template>
      </td>
    </ng-container>
  </div>

  <td role="cell position-relative"
    *ngIf="(!readonly || options.isSaveForLater || options.displayAddToCart) && !isBundleItem && item.updateable"
    class="cx-actions">
    <ng-container *ngIf="!isProductOutOfStock(item.product)">
      <ng-container *ngTemplateOutlet="
          options.optionalBtn;
          context: {
            $implicit: {
              loading: quantityControl?.disabled,
              item: item,
              options: options,
              bundleId: bundleId
            }
          }
        "></ng-container>
    </ng-container>

    <span role="cell" *ngIf="isProductOutOfStock(item.product)" class="cx-availability">
      {{ "addToCart.outOfStock" | cxTranslate }}
    </span>

    <div class="cart-item-consumer-details">
      <button *ngIf="!readonly" (click)="removeEntry(item)" [cxAtMessage]="'cartItems.itemRemoved' | cxTranslate"
        [disabled]="quantityControl?.disabled" attr.aria-label="{{ 'addToCart.removeFromCart' | cxTranslate }}"
        class="link cx-action-link cx-remove-btn">
        <cx-icon [type]="iconTypes.TRASH"></cx-icon>
        {{ "common.remove" | cxTranslate }}
      </button>

      <div class="consumer-details-wrapper">
        <ng-container *ngIf="sppFormValue && mobileOnly">
          <button class="btn add-consumer-details-btn"
            [class.add-consumer-details-btn-expanded]="isConsumerDetailsSectionExpanded"
            (click)="expandConsumerDetailsSection()" (genSizeChanged)="onResize()">
            {{ (isBuilderSpp() ? 'cartItems.addBuilderDetails' : 'cartItems.addConsumerDetails') | cxTranslate }}
            <img src="../../../../../../assets/icons/expand_more_black_24.svg" />
          </button>

          <gen-spp-consumer-details-form [ngStyle]="{ 'margin-top': '8px' }"
            [hidden]="!isConsumerDetailsSectionExpanded" [sppFormValue]="sppFormValue" #consumerDetailsSection
            [quantity]="item.quantity" (genSizeChanged)="onResize()"
            [entryNumber]="item.entryNumber"></gen-spp-consumer-details-form>
        </ng-container>
      </div>
    </div>

    <ng-container *ngIf="!isBundleItem && item.product.displayItemAttentionMessage">
      <gen-no-return-warning #noReturnWarning (genSizeChanged)="onResize()" [ngClass]="{'bundle': bundleId}"
        [message]="item.product.displayItemAttentionMessage"></gen-no-return-warning>
    </ng-container>

    <ng-container *ngIf="!isBundleItem && item.product.engineReplacement">
      <gen-no-return-warning #atestationDataRestrictionMessage (genSizeChanged)="onResize()"
        [ngClass]="{'bundle': bundleId}" [message]="'productDetails.atestationDataRestrictionMessage' | cxTranslate"
        [color]="'#F9E6E6'"></gen-no-return-warning>
    </ng-container>

    <div class="material-note-container" #materialNote (genSizeChanged)="onResize()"
      *ngIf="isServicePartsEnabled && item.product.materialNotes && item.product.servicePart">
      <div class="sp-note-container">
        <span>
          <strong>Note: </strong>
          <span [innerHTML]="(item.product.materialNotes  || '') | safe"></span>
        </span>
      </div>
    </div>
  </td>
</ng-template>
<ng-template #total>
  <td role="cell" class="mobile-price-only">
    <div *ngIf="item?.basePrice && item.quantity && item.totalPrice"
      class="cx-total text-center d-flex align-items-center justify-content-center">
      <div class="cx-mobile-header">{{ "cartItems.total" | cxTranslate }}</div>
      <div *ngIf="item.basePrice?.value && item.totalPrice?.currencyIso" class="cx-value"
        [class]="{'text-crossed': !isBundleItem && item.adjustedWithPromoTotalPrice?.value && (item.basePrice?.value - item.adjustedWithPromoTotalPrice?.value  > 0)}">
        {{ item.basePrice?.value * item.quantity | currency : item.totalPrice.currencyIso}}
      </div>
    </div>
    <div
      *ngIf="item.adjustedWithPromoTotalPrice?.value && (item.basePrice?.value - item.adjustedWithPromoTotalPrice?.value)  > 0"
      class="cx-discount-total text-center">
      <div class="cx-value"
        *ngIf="item.adjustedWithPromoTotalPrice?.value && item.quantity && item.totalPrice?.currencyIso">
        {{
        item.adjustedWithPromoTotalPrice?.value * item.quantity
        | currency : item.totalPrice.currencyIso
        }}
      </div>
    </div>
  </td>
</ng-template>